'use client';

import { useRef, useState } from 'react';

/**
 * Detects whether a text element is being truncated (text-overflow: ellipsis).
 * Returns a ref to attach to the element and a check function to call on hover.
 * The tooltip should only be shown when `isTruncated` is true.
 */
export function useIsTruncated<T extends HTMLElement = HTMLElement>() {
  const ref = useRef<T>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  function checkTruncation() {
    const el = ref.current;
    if (el) setIsTruncated(el.scrollWidth > el.clientWidth);
  }

  return { ref, isTruncated, checkTruncation };
}
